ACC.fileuploadcommon = {
  bindAll: function(inputClass) {
    this.fileUploadClick(inputClass);
    $('.ph-common-file-upload-' + inputClass + ',.ph-drop-section-' + inputClass).on('dragover', function(e) {
      e.preventDefault();
      e.stopPropagation();
      ACC.fileuploadcommon.hideElement($('.ph-upload-section-' + inputClass + ',.ph-uploading-section-' + inputClass), true);
      ACC.fileuploadcommon.showElement($('.ph-drop-section-' + inputClass), true);
    }).on('dragleave', function(e) {
      e.preventDefault();
      e.stopPropagation();
    }).on('drop', function(e) {
      e.preventDefault();
      e.stopPropagation();
      ACC.fileuploadcommon.showElement($('.ph-uploading-section-' + inputClass), true);
      ACC.fileuploadcommon.hideElement($('.ph-upload-section-' + inputClass), true);

      var boxFile = document.querySelector('.ph-file-input-' + inputClass),
          fileItem = e.originalEvent.dataTransfer.files,
          itemName = e.originalEvent.dataTransfer.files[0].name;

      boxFile.files = fileItem;
      ACC.fileuploadcommon.getFileChange(boxFile, itemName, inputClass);
    });

    $('.ph-remove-upload-' + inputClass).on('click', function() {
      var removeUrl = $(this).attr('data-removeUrl');

      if (removeUrl === '') {
        ACC.fileuploadcommon.resetDiv(inputClass);
      } else {
        var obj = {},
            resetMsg = $('.ph-file-name-' + inputClass).attr('data-default'),
            parentForm = document.getElementById($('.ph-file-input-' + inputClass).attr('data-parentForm'));

        obj.formData = new FormData(parentForm);
        obj.path = removeUrl;
        obj.fId = '.ph-file-input-' + inputClass;
        obj.resetMsg = resetMsg;
        ACC.fileuploadcommon.removeFilebutton(obj, inputClass);
      }
    });

    $('.ph-retry-upload-' + inputClass).on('click', function() {
      ACC.fileuploadcommon.resetDiv(inputClass);
    });
  },
  getFileChange: function(e, fileItemName, inputClass) {
    var file = '',
        obj = {},
        resetMsg = $('.ph-file-name-' + inputClass).attr('data-default'),
        parentForm = document.getElementById($('.ph-file-input-' + inputClass).attr('data-parentForm'));

    obj.formData = new FormData(parentForm);
    obj.path = $('.ph-file-input-' + inputClass).attr('data-uploadUrl');
    obj.fId = '.ph-file-input-' + inputClass;
    obj.resetMsg = resetMsg;

    var backendFileName = inputClass.replace(/^./, inputClass[0].toUpperCase());

    if (fileItemName && fileItemName.length > 0) {
      obj.formData.append(backendFileName + 'FileName', fileItemName);
      file = fileItemName;
    } else {
      file = e.files[0].name;
    }

    $('.ph-file-name-' + inputClass).html(file);
    ACC.fileuploadcommon.uplodDocButton(obj, e, inputClass);
  },
  resetDiv: function(inputClass) {
    ACC.fileuploadcommon.hideElement($('.ph-drop-section-' + inputClass + ',.ph-uploading-section-' + inputClass), true);
    ACC.fileuploadcommon.showElement($('.ph-upload-section-' + inputClass), true);
    $('.ph-file-name-' + inputClass).html($('.ph-file-name-' + inputClass).attr('data-default'));
    $('.ph-file-input-' + inputClass).val('');
  },
  showError: function(inputClass) {
    var errorMsg = $('.ph-status-message-' + inputClass).attr('data-errorMsg');

    $('.ph-status-message-' + inputClass).html(errorMsg);
    ACC.fileuploadcommon.showElement($('.ph-status-message-' + inputClass + ',.ph-retry-upload-' + inputClass));
    ACC.fileuploadcommon.hideElement($('.ph-progress-status-' + inputClass + ',.ph-cancel-upload-' + inputClass + ',.ph-progress-' + inputClass + ',.ph-remove-upload-' + inputClass));
  },
  showElement: function(element, isFlex) {
    if (isFlex) {
      $(element).removeClass('ph-d-none').addClass('ph-d-flex');
    } else {
      $(element).removeClass('ph-d-none');
    }
  },
  hideElement: function(element, isFlex) {
    if (isFlex) {
      $(element).removeClass('ph-d-flex').addClass('ph-d-none');
    } else {
      $(element).addClass('ph-d-none');
    }
  },
  uplodDocButton: function(obj, event, inputClass) {
    ACC.fileuploadcommon.showElement($('.ph-uploading-section-' + inputClass), true);
    ACC.fileuploadcommon.hideElement($('.ph-upload-section-' + inputClass), true);
    ACC.fileuploadcommon.hideElement($('.ph-status-message-' + inputClass + ',.ph-remove-upload-' + inputClass));
    ACC.fileuploadcommon.showElement($('.ph-progress-status-' + inputClass + ',.ph-cancel-upload-' + inputClass + ',.ph-progress-' + inputClass));

    if ((/(\.exe)$/i).test($('.ph-file-name-' + inputClass).html()) === false) {
      var fileSize = event.files[0].size,
          fileSizeInMb = Number(parseFloat(fileSize / 1024 / 1000).toFixed(2));

      if (fileSizeInMb <= 10.00) {
        var filexhr = $.ajax({
          xhr: function() {
            var xhr = new window.XMLHttpRequest();

            xhr.upload.addEventListener('progress', function(e) {
              if (e.lengthComputable) {
                var percent = Math.round((e.loaded / e.total) * 100);

                $('.ph-progress-bar-' + inputClass).attr('aria-valuenow', percent).css('width', percent + '%');
                $('.ph-progress-percentage-' + inputClass).text(percent + '%');
              }
            });

            return xhr;
          },
          url: obj.path,
          type: 'post',
          data: obj.formData,
          contentType: false,
          processData: false,
          enctype: 'multipart/form-data',
          success: function() {
            var successMsg = $('.ph-status-message-' + inputClass).attr('data-successMsg');

            $('.ph-status-message-' + inputClass).html(successMsg);
            ACC.fileuploadcommon.showElement($('.ph-status-message-' + inputClass + ',.ph-remove-upload-' + inputClass));
            ACC.fileuploadcommon.hideElement($('.ph-drop-section-' + inputClass + ',.ph-progress-status-' + inputClass + ',.ph-cancel-upload-' + inputClass + ',.ph-progress-' + inputClass + ',.ph-retry-upload-' + inputClass), true);
          },
          error: function() {
            ACC.fileuploadcommon.showError(inputClass);
          }
        });

        $('.ph-cancel-upload-' + inputClass).on('click', function() {
          filexhr.abort();
          ACC.fileuploadcommon.resetDiv(inputClass);
        });
      } else {
        $(obj.fId).val('');
        $('.ph-status-message-' + inputClass).html($('.ph-status-message-' + inputClass).attr('data-sizeError'));
        ACC.fileuploadcommon.showElement($('.ph-status-message-' + inputClass + ', .ph-progress-' + inputClass + ', .ph-retry-upload-' + inputClass));
        ACC.fileuploadcommon.hideElement($('.ph-drop-section-' + inputClass + ',.ph-progress-status-' + inputClass + ',.ph-cancel-upload-' + inputClass + ',.ph-progress-' + inputClass + ',.ph-remove-upload-' + inputClass), true);
      }
    } else {
      $(obj.fId).val('');
      $(obj.fId).focus();
      $('.ph-status-message-' + inputClass).html($('.ph-status-message-' + inputClass).attr('data-wrongFile'));
      ACC.fileuploadcommon.showElement($('.ph-status-message-' + inputClass + ',.ph-retry-upload-' + inputClass));
      ACC.fileuploadcommon.hideElement($('.ph-drop-section-' + inputClass + ',.ph-progress-status-' + inputClass + ',.ph-cancel-upload-' + inputClass + ',.ph-progress-' + inputClass + ',.ph-remove-upload-' + inputClass), true);
    }
  },
  fileUploadClick: function(inputClass) {
    $('.ph-file-choose-btn-' + inputClass).on('click', function() {
      var $fileInput = $(this).closest('.ph-upload-section-' + inputClass).find('.ph-file-input-' + inputClass);

      $fileInput.trigger('click');
    });
  },
  removeFilebutton: function(obj, inputClass) {
    $.ajax({
      url: obj.path,
      type: 'post',
      data: obj.formData,
      contentType: false,
      processData: false,
      enctype: 'multipart/form-data',
      success: function() {
        ACC.fileuploadcommon.resetDiv(inputClass);
      }
    });
  }
};

$(document).ready(function() {
  ACC.fileuploadcommon.bindAll('preview');
  ACC.fileuploadcommon.bindAll('bankReference');
});
